<template>
    <div id="contenedor-eliminar-solicitud-obra">
      <v-card>
        <v-card-title class="secondary--text"> Eliminar Solicitud de Obra </v-card-title>
        <v-card-text>
          <span class="secondary--text"> ¿Desea eliminar la solicitud de obra? </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3"
          >
          </custom-button>
          <custom-button
            @click="mixEliminarSolicitudObra"
            :disabled="enviandoFormulario"
            tipo="formAceptar"
            label="Eliminar"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </div>
  </template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import mixSolicitudesObras from './mixSolicitudesObras';

export default {
  name: 'EliminarSolicitudObra',
  mixins: [mixSolicitudesObras],
  props: {
    solicitudObraEliminar: Object,
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

  <style>
  </style>
